import AccountOpening from '@advisor/models/store/settings/onboarding/AccountOpening';
import FeatureList from '@advisor/models/store/settings/FeatureList';

export default class SegmentSetting {
  constructor() {
    this.segmentId = null;
    this.segmentLabel = null;
    this.isDefault = false;
    this.onboarding = {
      accountOpening: new AccountOpening(),
      goals: [],
      accounts: SegmentSetting.getAccounts(),
    };
    this.featureList = [];
    this.portalPermissions = SegmentSetting.getPortalPermissions();
  }

  static make(mixObj) {
    const objSegmentSetting = new SegmentSetting();

    return Object.assign(objSegmentSetting, mixObj);
  }

  static getAccounts() {
    return [
      FeatureList.INDIVIDUAL,
      FeatureList.TRADITIONAL_IRA,
      FeatureList.ROTH_IRA,
      FeatureList.SEP_IRA,
      FeatureList.SIMPLE_IRA,
    ];
  }

  static getPortalPermissions() {
    return [
      FeatureList.GOAL,
      FeatureList.ACCOUNT,
      FeatureList.TRANSFER_MONEY,
      FeatureList.PERFORMANCE_REPORTING,
      FeatureList.ASSET_ALLOCATION,
      FeatureList.WEALTH_PROJECTION,
      FeatureList.RISK_TOLERANCE,
    ];
  }
}
